import React from 'react';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';

import RichText from '../Prismic/RichText';
import { prismicImage } from 'src/common/utils/prismic-image';
import './LogoIconCollection.scss';

const LogoIconCollection = props => (
  <section className="logo-icon-collection">
    <div className="container-guttered">
      <RichText className="logo-icon-collection-title" fields={props.title} />
      <div className="logo-icon-collection-item-container">
        {props.items.map((item, i) => (
          <div className="logo-icon-collection-item" key={i}>
            <LazyLoad>
              <img src={prismicImage(item.image)} alt="" />
            </LazyLoad>
            <RichText
              className="logo-icon-collection-content"
              fields={item.content}
            />
          </div>
        ))}
      </div>
    </div>
  </section>
);

LogoIconCollection.propTypes = {
  title: PropTypes.array.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.object.isRequired,
      content: PropTypes.array.isRequired
    })
  ).isRequired
};

export default LogoIconCollection;



// WEBPACK FOOTER //
// ./src/client/js/view/components/LogoIconCollection/LogoIconCollection.js